/**
 * RevealCountdownIcon — Auge mit kreisfoermigem Countdown-Ring.
 *
 * Zeigt den verbleibenden Prozent-Anteil als SVG-Ring um das EyeOff-Icon.
 * Wenn nicht sichtbar, einfaches Eye-Icon ohne Ring.
 */
import React from 'react';
import { Eye, EyeOff } from 'lucide-react';

export const RevealCountdownIcon = ({ visible, remainingPct = 0, size = 18 }) => {
  if (!visible) {
    return <Eye style={{ width: size, height: size }} />;
  }
  const r = (size - 4) / 2;
  const c = 2 * Math.PI * r;
  const offset = c * (1 - remainingPct / 100);
  return (
    <span className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg
        width={size}
        height={size}
        className="absolute inset-0 -rotate-90 text-primary"
        aria-hidden
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke="currentColor"
          strokeOpacity="0.15"
          strokeWidth="1.5"
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
          strokeDasharray={c}
          strokeDashoffset={offset}
          style={{ transition: 'stroke-dashoffset 250ms linear' }}
        />
      </svg>
      <EyeOff style={{ width: size - 6, height: size - 6 }} />
    </span>
  );
};

export default RevealCountdownIcon;
